// extracted by mini-css-extract-plugin
export default {"addToCartControl":"b2-z","giftCard":"c2-z","btnContainer":"d2-z","cartButton":"e2-z","disabled":"f2-z"};